import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getJumpUrlHost } from '@src/utils/index';

const Category = ({ marketVarietiesList, allMarket }) => {
    const filterQuoteCode = marketVarietiesList.map(item => item.quoteCode);
    const filterStockName = ['英国富时100指数', '法国CAC40指数', '马来西亚富时综合指数', '新华富时中国A50指数']; // FTSE PARI KLSI
    let stockList = allMarket.filter(item => filterQuoteCode.includes(item.quoteCode));

    stockList = stockList.filter(item => !filterStockName.includes(item.name));

    return (
        <div className={styles.category}>
            {/* <div className={styles.categoryNav}>
                <div className={`${styles.categoryNavItem} ${styles.active}`}>亚洲</div>
                <div className={`${styles.categoryNavItem}`}>欧洲</div>
            </div> */}
            <div className={styles.categoryContent}>
                <table className={styles.categoryTable}>
                    <thead className={styles.categoryThead}>
                        <tr>
                            <th className={styles.categoryCell}>名称</th>
                            <th className={styles.categoryCell}>最新价</th>
                            <th className={styles.categoryCell}>开盘价</th>
                            <th className={styles.categoryCell}>最高价</th>
                            <th className={styles.categoryCell}>最低价</th>
                            <th className={styles.categoryCell}>涨跌额</th>
                            <th className={styles.categoryCell}>涨跌幅度</th>
                            <th className={styles.categoryCell}>时间</th>
                        </tr>
                    </thead>
                    <tbody className={styles.categoryTbody}>
                        {stockList.map((item, index) => {
                            let statusFlag = item.range.includes('-') ? 'down' : 'up';
                            const statusClassList = {
                                down: styles.categoryGreenText,
                                up: styles.categoryRedText,
                                flat: styles.categoryGrayText,
                            };

                            statusFlag = item.range.includes('--') ? 'flat' : statusFlag;

                            return (
                                <tr key={index} className={styles.categoryRow}>
                                    <td className={styles.categoryCell}>
                                        <div className={styles.categoryCellName}>
                                            <a
                                                href={`${getJumpUrlHost(
                                                    'pc',
                                                )}/marketDetail?quoteCode=${encodeURIComponent(item.quoteCode)}`}
                                                rel="noopener noreferrer"
                                                target="_blank">
                                                {item.name}
                                            </a>
                                        </div>
                                        <div className={styles.categoryCellEn}>{item.quotationShowName}</div>
                                    </td>
                                    <td className={styles.categoryCell}>{item.tradePrice}</td>
                                    <td className={styles.categoryCell}>{item.openPrice}</td>
                                    <td className={styles.categoryCell}>{item.highPrice}</td>
                                    <td className={styles.categoryCell}>{item.lowPrice}</td>
                                    <td className={styles.categoryCell}>
                                        <span className={statusClassList[statusFlag]}>
                                            {statusFlag === 'up' ? `+${item.range}` : item.range}
                                        </span>
                                    </td>
                                    <td className={styles.categoryCell}>
                                        <span className={statusClassList[statusFlag]}>
                                            {statusFlag === 'up' ? `+${item.rangePercent}` : item.rangePercent}
                                        </span>
                                    </td>
                                    <td className={styles.categoryCell}>
                                        <span>{item.date}</span>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

Category.propTypes = {
    marketVarietiesList: PropTypes.array,
    allMarket: PropTypes.array,
};

export default errorBoundary(Category);
